(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camali-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('camali-review-carousel')) {
    customElements.define('camali-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.cm-reviews__track');
        const previous = this.querySelector('[data-review-prev]');
        const next = this.querySelector('[data-review-next]');
        if (!track || !previous || !next) return;
        const rtl = getComputedStyle(track).direction === 'rtl';
        const sync = () => {
          const position = Math.abs(track.scrollLeft);
          previous.disabled = position < 2;
          next.disabled = position >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = (direction) => {
          const card = track.querySelector('.cm-reviews__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).gap) || 16;
          track.scrollBy({ left: direction * (rtl ? -1 : 1) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', sync, { signal, passive: true });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(sync);
        this.observer.observe(track);
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
